/**
 * cart.js — phần giao diện chung của giỏ hàng demo: số đếm trên header + tab bar,
 * mini cart thả dưới nút "Giỏ hàng", và mọi nút "Thêm" / "Mua ngay" trong trang.
 *
 * Nút thêm vào giỏ chỉ cần thuộc tính:
 *   [data-add-to-cart]  nằm trong [data-product][data-product-id] (card, trang sản phẩm)
 *                       hoặc tự mang data-product-id
 *   [data-buy-now]      như trên nhưng thêm xong chuyển thẳng sang thanh toán
 * Số lượng lấy từ ô [data-qty-source] gần nhất trong cùng [data-product] (trang sản phẩm),
 * không có thì là 1. Dung tích đang chọn đọc từ input[name="variant"]:checked.
 *
 * WP: WooCommerce đã có add_to_cart AJAX + fragments, xoá file này và đổi
 * data-add-to-cart thành class ajax_add_to_cart + data-product_id.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var DESKTOP_QUERY = '(min-width: 1024px)';

    function store() {
        return window.WBStore;
    }

    function esc(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
    }

    // ----- Số đếm -----
    function renderCounts() {
        var count = store().cart.count();
        [].slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function (el) {
            el.textContent = count > 99 ? '99+' : String(count);
            el.hidden = count === 0;
        });
    }

    // ----- Mini cart -----
    var root = document.querySelector('[data-mini-cart-root]');
    var toggle = root ? root.querySelector('[data-mini-cart-toggle]') : null;
    var panel = root ? root.querySelector('[data-mini-cart]') : null;

    function renderMiniCart() {
        if (!panel) return;
        var s = store();
        var items = s.cart.items();
        var html = '<div class="mini-cart__head"><span>Giỏ hàng (' + s.cart.count() + ')</span>' +
            '<button class="mini-cart__close" type="button" aria-label="Đóng giỏ hàng" data-mini-cart-close>' +
            '<i class="ph-bold ph-x" aria-hidden="true"></i></button></div>';

        if (!items.length) {
            html += '<div class="empty-state"><span class="empty-state__icon"><i class="ph-bold ph-shopping-cart-simple" aria-hidden="true"></i></span>' +
                '<p class="empty-state__title">Giỏ hàng đang trống</p>' +
                '<p class="empty-state__text">Chọn vài chai vang yêu thích rồi quay lại đây nhé.</p>' +
                '<a class="btn btn--secondary btn--compact" href="archive-product.html">Khám phá cửa hàng</a></div>';
        } else {
            html += '<ul class="mini-cart__list">';
            items.forEach(function (item) {
                var key = s.cart.key(item);
                html += '<li class="mini-cart__item">' +
                    '<span class="thumb"><img src="' + esc(item.image) + '" alt="" width="600" height="800" /></span>' +
                    '<div class="mini-cart__info"><a href="' + esc(item.url) + '">' + esc(item.name) + (item.year ? ' ' + esc(item.year) : '') + '</a>' +
                    '<span>' + item.qty + ' × ' + s.money(item.price) + (item.variant ? ' · ' + esc(item.variant) : '') + '</span></div>' +
                    '<button class="mini-cart__remove" type="button" aria-label="Xoá ' + esc(item.name) + ' khỏi giỏ" data-cart-remove="' + esc(key) + '">' +
                    '<i class="ph-bold ph-trash" aria-hidden="true"></i></button></li>';
            });
            html += '</ul><div class="mini-cart__foot">' +
                '<div class="mini-cart__total"><span>Tạm tính</span><strong>' + s.money(s.cart.subtotal()) + '</strong></div>' +
                '<div class="mini-cart__actions"><a class="btn btn--secondary" href="cart.html">Xem giỏ</a>' +
                '<a class="btn btn--primary" href="checkout.html">Thanh toán</a></div></div>';
        }
        panel.innerHTML = html;
    }

    function setMiniCart(open) {
        if (!panel || !toggle) return;
        if (open) renderMiniCart();
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (toggle && panel) {
        // Mobile không có mini cart: nút là link thẳng sang trang giỏ hàng
        toggle.addEventListener('click', function (event) {
            if (!window.matchMedia(DESKTOP_QUERY).matches) return;
            event.preventDefault();
            setMiniCart(panel.hidden);
        });

        panel.addEventListener('click', function (event) {
            if (event.target.closest('[data-mini-cart-close]')) {
                setMiniCart(false);
                toggle.focus();
            }
        });

        document.addEventListener('click', function (event) {
            if (!panel.hidden && !root.contains(event.target)) setMiniCart(false);
        });

        document.addEventListener('keydown', function (event) {
            if ((event.key === 'Escape' || event.key === 'Esc') && !panel.hidden) {
                setMiniCart(false);
                toggle.focus();
            }
        });
    }

    // ----- Xoá dòng (mini cart, trang giỏ hàng dùng chung thuộc tính) -----
    document.addEventListener('click', function (event) {
        var remove = event.target.closest ? event.target.closest('[data-cart-remove]') : null;
        if (!remove) return;
        event.preventDefault();
        var key = remove.getAttribute('data-cart-remove');
        var item = store().cart.items().filter(function (it) {
            return store().cart.key(it) === key;
        })[0];
        store().cart.remove(key);
        if (window.WBToast && item) {
            window.WBToast.show('Đã xoá ' + item.name + ' khỏi giỏ hàng');
        }
    });

    // ----- Thêm vào giỏ / Mua ngay -----
    function snapshotFrom(button) {
        var holder = button.closest('[data-product]');
        var id = button.getAttribute('data-product-id') || (holder && holder.getAttribute('data-product-id'));
        var snap = store().product(id, holder || button);
        if (!snap) return null;

        var scope = holder || document;
        var variant = scope.querySelector('input[name="variant"]:checked');
        if (variant) {
            snap.variant = variant.value;
            if (variant.getAttribute('data-price')) snap.price = Number(variant.getAttribute('data-price'));
            if (variant.getAttribute('data-regular-price')) snap.regularPrice = Number(variant.getAttribute('data-regular-price'));
        }
        return snap;
    }

    function qtyFrom(button) {
        var holder = button.closest('[data-product]');
        var input = holder ? holder.querySelector('[data-qty-source]') : null;
        return input ? input.value : 1;
    }

    // Phản hồi ngay trên nút: icon đổi sang dấu tích 1,2 giây
    function flash(button) {
        var icon = button.querySelector('i');
        if (!icon) return;
        var original = icon.className;
        icon.className = 'ph-bold ph-check';
        button.classList.add('is-added');
        window.clearTimeout(button._flash);
        button._flash = window.setTimeout(function () {
            icon.className = original;
            button.classList.remove('is-added');
        }, 1200);
    }

    document.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-add-to-cart], [data-buy-now]') : null;
        if (!button || button.disabled) return;
        event.preventDefault();

        var snap = snapshotFrom(button);
        if (!snap) return;
        store().cart.add(snap, qtyFrom(button));

        if (button.hasAttribute('data-buy-now')) {
            window.location.href = 'checkout.html';
            return;
        }

        flash(button);
        if (window.WBToast) {
            window.WBToast.show('Đã thêm vào giỏ hàng', {
                icon: 'ph-fill ph-check-circle',
                action: { label: 'Xem giỏ', href: 'cart.html' }
            });
        }
    });

    function init() {
        if (!store()) return;
        renderCounts();
        document.addEventListener('wb:cart', function () {
            renderCounts();
            if (panel && !panel.hidden) renderMiniCart();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
